module.exports = __webpack_public_path__ + "img/dashboard.f9ea4669.svg";